import { fg } from '@atlaskit/platform-feature-flags/fg';

import { BridgeClientError } from '../../custom-ui/bridge';
import type { OpenPanelPayload } from '../../custom-ui/bridge/types';
import type { MakeBridgeContext } from '../types';
import type { TBridgeMethod } from './types';

type PanelContext = MakeBridgeContext<'bridgeConfig'>;

export const PANEL_NOT_AVAILABLE_ERROR_MESSAGE = 'Panel API is not available for this instance.';

// Panels are rendered by the host product, so these resolve to false when the host doesn't
// provide the matching BridgeConfig callback.

export const openPanel: TBridgeMethod<PanelContext, OpenPanelPayload, boolean> = async (
	{ bridgeConfig },
	payload,
) => {
	if (!fg('platform_forge_ui_panel_bridge')) {
		throw new BridgeClientError(PANEL_NOT_AVAILABLE_ERROR_MESSAGE);
	}
	if (!bridgeConfig.openPanel) {
		return false;
	}
	return bridgeConfig.openPanel(payload) ?? true;
};

export const closePanel: TBridgeMethod<PanelContext, void, boolean> = async ({ bridgeConfig }) => {
	if (!fg('platform_forge_ui_panel_bridge')) {
		throw new BridgeClientError(PANEL_NOT_AVAILABLE_ERROR_MESSAGE);
	}
	if (!bridgeConfig.closePanel) {
		return false;
	}
	return bridgeConfig.closePanel() ?? true;
};
